import moment from 'moment-timezone';
import { trim_reason } from '../../../util_components/required_reason_textarea/reason_rules';
import {
  KIND_CANCEL,
  ist_input_to_iso
} from '../../../util_components/care_request/care_request_rules';
import {
  build_pause_cancel_payload,
  build_pause_care_records,
  cancelled_session_uuids,
  student_requested_at_error
} from '../student_profile/VacationPauseMembership/pause_cancel_payload';

export const YOGA = 'YOGA';
export const GROUP_SESSION_STUDENT = 'GROUP_SESSION_STUDENT';

export const repeat_session_type = (is_group_cancel) =>
  is_group_cancel ? GROUP_SESSION_STUDENT : YOGA;

// Nothing pre-picked: Care must choose who asked (Kuldeep, A-52); a group participant cancel asks nothing.
// eslint-disable-next-line no-unused-vars
export const initial_student_fields = (is_group_cancel) => ({
  cancelled_by_student: false,
  student_requested_at: '',
  cancelled_by_teacher: false,
  cancelled_by_admin: false,
  teacher_requested_at: '',
  requested_error: '',
  who_error: false
});

// Student, Teacher or Admin (the team): one side at a time; picking the picked side clears it.
export const pick_repeat_side = (state, side) => {
  const teacher = side === 'teacher' ? !state.cancelled_by_teacher : false;
  return {
    cancelled_by_student: side === 'student' ? !state.cancelled_by_student : false,
    cancelled_by_teacher: teacher,
    cancelled_by_admin: side === 'admin' ? !state.cancelled_by_admin : false,
    teacher_requested_at: teacher ? state.teacher_requested_at : '',
    requested_error: '',
    who_error: false
  };
};

// A 1-on-1 series cancel must say who asked (required, PROD-7828 A-52); not asked when nothing is cancelled.
export const repeat_who_missing = (state) =>
  !state.is_group_cancel &&
  !!state.cancel_all_future &&
  !state.cancelled_by_student &&
  !state.cancelled_by_teacher &&
  !state.cancelled_by_admin;

const CLOCK_SKEW_MS = 2 * 60 * 1000;
const teacher_cancel = (state) =>
  !state.is_group_cancel && !!state.cancel_all_future && !!state.cancelled_by_teacher;

// A teacher-asked series cancel needs when the teacher asked (apis: teacher_cancel_requested_at).
const teacher_requested_error = (state, now_ms) => {
  const iso = ist_input_to_iso(state.teacher_requested_at);
  if (!iso) return 'Enter when the teacher asked to cancel (IST).';
  if (moment(iso).valueOf() > now_ms + CLOCK_SKEW_MS) return "Requested at can't be in the future.";
  return '';
};

// only when classes are cancelled: switching the series off alone cancels nothing, so no request time is used
export const shows_student_fields = (is_group_cancel, cancel_all_future) =>
  !is_group_cancel && !!cancel_all_future;

// page state -> the shape the shared pause helpers read
const as_pause_state = (state) => ({
  cancelled_by_student: !state.is_group_cancel && !!state.cancelled_by_student,
  student_requested_at: state.student_requested_at,
  cancel_reason: state.cancel_reason
});

export const repeat_requested_error = (state, now_ms) => {
  if (!state.cancel_all_future) return '';
  if (teacher_cancel(state)) return teacher_requested_error(state, now_ms);
  return student_requested_at_error(
    as_pause_state(state),
    now_ms,
    repeat_session_type(state.is_group_cancel)
  );
};

export const build_repeat_cancel_request = (state) => {
  const base = {
    // the group route is keyed by participant id with no student, so this is its only audit link
    student_uuid: state.student_uuid,
    repeat_session_uuid: state.session_uuid,
    cancel_all_future_sessions: state.cancel_all_future ? 1 : 0
  };
  if (state.is_group_cancel) {
    return {
      url_key: 'cancel_student_repeat_group_session',
      payload: {
        ...base,
        cancel_reason: trim_reason(state.cancel_reason),
        repeat_group_session_participant_id: state.repeat_group_session_participant_id
      }
    };
  }
  const payload = build_pause_cancel_payload(base, as_pause_state(state));
  if (teacher_cancel(state)) {
    payload.cancelled_by_student = 0;
    payload.cancelled_by_teacher = 1;
    payload.cancelled_by_admin = 1;
    payload.teacher_cancel_requested_at = ist_input_to_iso(state.teacher_requested_at);
  }
  return { url_key: 'cancel_repeat_sessions', payload };
};

// One Care CANCEL record per cancelled 1-on-1: who asked and when (teacher or student).
export const repeat_care_records_for = (state, sessionUuids, makeUuid) => {
  if (teacher_cancel(state)) {
    const requested_at = ist_input_to_iso(state.teacher_requested_at);
    if (!requested_at) return [];
    return sessionUuids.map((session_uuid) => ({
      uuid: makeUuid(),
      session_uuid,
      change_kind: KIND_CANCEL,
      initiated_by: 'TEACHER',
      requested_at,
      note: trim_reason(state.cancel_reason)
    }));
  }
  return build_pause_care_records({
    sessionUuids,
    sessionType: repeat_session_type(state.is_group_cancel),
    cancelState: as_pause_state(state),
    makeUuid
  });
};

export const repeat_care_records = (state, response, makeUuid) =>
  repeat_care_records_for(state, cancelled_session_uuids(response), makeUuid);
